<template>
  <div class="reason-action-box">
    <el-dialog top="20px" :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose" align="center" :close-on-click-modal="false" class="el-dialogs">
      <el-form ref="form" :model="params" :rules="rules" :label-position="labelPosition" label-width="100px">
        <el-form-item label="原因列表:"  prop="content" align="left">
          <!-- <span>原因列表</span> -->
          <el-table ref="table" :data="tableData" border highlight-current-row @current-change="handlerSelect">
            <el-table-column prop="content" label="原因" align="center" />
          </el-table>
        </el-form-item>
          <el-form-item label="截图:" prop="lockImg" v-if="type!=='vid'">
            <UploadImgPaste @changeImgUrl='changeImgUrl' :img='params.lockImg'></UploadImgPaste>
          </el-form-item>
      </el-form>

      <div v-if="total>pageSize" class="table-pagination">
        <el-pagination :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="flag" size="small" @click="submitForm('form')">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { reasonList, rejectPost } from '@/api/video/post'
import API from "@/api";
import baseConfig from '@/utils/serverUrlConfig'
import UploadImgPaste from './clipboardPic.vue'

export default {
  data() {
    return {
      type: '',
      labelPosition: 'left',
      // 外层弹出框
      dialogVisible: false,
      // 弹窗标题
      title: '原因',
      // 提交按钮状态
      flag: false,
      // 内层弹窗表格加载状态
      loading: false,
      // 编辑id
      id: '',
      // 新增帖子请求参数
      params: {
        content: '',
                lockImg: ''
      },
      tableData: [],
      pageSize: 5,
      pageNum: 1,
      total: 0,
      action: baseConfig.baseServerUrl + '/vid/uploadStatic',
      // 验证规则
      rules: {
        content: [
          { required: true, message: '请选择原因', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
  },
  components:{UploadImgPaste},
  methods: {
    handlerSelect(currentRow) {
      if (currentRow) {
        this.params.content = currentRow.content
      } else {
        this.params.content = ''
      }
    },
    // 获取驳回原因列表
    getReasonList() {
      this.loading = true
      const params = Object.assign({}, {
        type: this.type,
        page: this.pageNum,
        pageSize: this.pageSize
      })
      API.getReasonList(params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.total = res.data.total
          this.tableData = res.data.list || []
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.tableData = []
        this.loading = false
      })
    },
    handleSizeChange(val) {
      window.console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getReasonList()
    },
    // 数据提交验证
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.flag = true
          switch(this.type){
            case 'user':
              this.handleLock()
              break
            case 'upload':
              this.udpateForbid()
              break
            case 'vid':
              this.examineVideo()
              break
            default:
              this.$message.error('操作失败,请重试')
              return false
          }
          this.handleClose()
        } else {
          return false
        }
      })
    },
    examineVideo() {
      const params = Object.assign({}, {
        ids: [this.id],
        pass: 2,
        reason: this.params.content
      })
      API.examineVideo(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功！',
            type: 'success'
          });
          this.$emit('handleList')
        } else {
          this.$message.error('操作失败！')
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
        this.$message.error('操作失败！')
      })
    },
    // 禁止用户上传文件
    udpateForbid(){
      const params = Object.assign({}, {
        uidList: [this.id],
        enable: true,
        reason: this.params.content
      })
      API.resetForbid(params)
        .then(res => {
          res.code === 200 && (
            this.$message.success('修改用户禁止上传文件状态成功！'),this.$emit('handleList')
          )
          this.handleClose()
          this.flag = false
        })
        .catch(() => {
          this.$message.error('操作失败，请重试')
          this.handleClose()
          this.flag = false
        })
    },
    // 封禁用户
    handleLock() {
      const params = Object.assign({}, {
        uid: this.id,
        enable: true,
        reason: this.params.content,
        lockImg: this.params.lockImg
      })
      API.getUserLock(params)
        .then(res => {
          if (res.code === 200) {
            if (params.enable) {
              this.$message({
                message: "封禁用户成功",
                type: "success"
              });
              this.$emit('handleList')
            } else {
              this.$message({
                message: "解封用户成功",
                type: "success"
              });
            }
            // this.search();
          }
          this.handleClose()
          this.flag = false
        })
        .catch(() => {
          this.$message.error('封禁失败！')
          this.flag = false
          this.handleClose()
        });
    },
    // 图片上传成功回调
    // successCallback1(res) {
    //   this.params.lockImg = res.data.coverImg
    // },
      changeImgUrl(data) {
       this.params.lockImg = data
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$refs.table.setCurrentRow()
      this.params = {
        content: '',
      }
      this.pageSize = 10
      this.pageNum = 1
      this.flag = false
      this.$refs.form.resetFields()
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data, type) {
      this.dialogVisible = true
      this.type = type
      this.id = parseInt( data.uid || data.userID)||data.id
      this.getReasonList()
    }
  }
}
</script>

<style lang="scss" scoped>
.reason-action-box {
  .inline {
    display: flex;
    align-items: center;
  }
  /deep/.el-table__body tr.current-row > td {
    background-color: #1890ff;
    color: #fff;
  }
}
</style>
